var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5934_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2008.79 595.264C1898.17 484.638 1748.7 421.596 1592.27 419.578C1435.83 417.56 1284.79 476.725 1171.35 584.46C1057.91 692.196 991.031 839.981 984.978 996.313C978.924 1152.65 1034.17 1305.16 1138.95 1421.34L1397.96 1187.77C1354.09 1139.13 1330.96 1075.27 1333.49 1009.81C1336.02 944.35 1364.03 882.471 1411.53 837.361C1459.03 792.25 1522.27 767.478 1587.77 768.323C1653.27 769.168 1715.85 795.564 1762.17 841.884L2008.79 595.264Z",
    fill: "#E4E9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.792 -561.736C480.363 -505.165 525.049 -437.852 555.222 -363.756C585.394 -289.66 600.444 -210.279 599.485 -130.281C598.526 -50.2836 581.579 28.7145 549.639 102.066C517.699 175.417 471.413 241.64 413.502 296.839C355.592 352.038 287.227 395.098 212.429 423.486C137.632 451.874 57.9124 465.016 -22.0393 462.14C-101.991 459.265 -180.56 440.428 -253.125 406.74C-325.689 373.052 -390.784 325.191 -444.579 265.974L-192.859 37.3009C-169.555 62.9536 -141.356 83.6867 -109.921 98.2806C-78.486 112.874 -44.4499 121.034 -9.81482 122.28C24.8202 123.526 59.3546 117.832 91.7569 105.535C124.159 93.2371 153.775 74.5835 178.862 50.6714C203.948 26.7593 224 -1.92853 237.836 -33.7042C251.672 -65.4799 259.014 -99.7019 259.429 -134.357C259.845 -169.012 253.325 -203.4 240.255 -235.498C227.184 -267.596 207.826 -296.756 183.319 -321.263L423.792 -561.736Z",
    fill: "#E4E9FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5934_907",
    x: -544.579,
    y: -661.736,
    width: 2653.37,
    height: 2183.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_5934_907"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.febb257c9b564a36627eb80cb1d620fe.svg";
export { ForwardRef as ReactComponent };